import { render, staticRenderFns } from "./TaskDetails.vue?vue&type=template&id=6cac6d20&scoped=true&"
import script from "./TaskDetails.vue?vue&type=script&lang=js&"
export * from "./TaskDetails.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetails.vue?vue&type=style&index=0&id=6cac6d20&lang=scss&scoped=true&"
import style1 from "./TaskDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cac6d20",
  null
  
)

export default component.exports